import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'app/rootReducer'
import './styles.scss'

import {
  UPDATE_ACCOUNT_EMAIL_ADDRESS,
  UpdateAccountEmailAddressVariables,
  UpdateAccountEmailAddressResponse,
  UpdateAccountEmailAddressResponseData
} from 'share/mutations/account'
import { setEmailAddress } from 'reducers/authentication/authenticationSlice'
import { setEmailAddress as setUserProfileEmailAddress } from 'reducers/userprofile/userprofileSlice'
import GoBackHeader from 'components/organisms/GoBackHeader'
import UserProfileChangeEmailAddressForm from 'components/organisms/UserProfileChangeEmailAddressForm'
import { Col, Row } from 'react-bootstrap'
import ErrorMessage from 'components/atoms/ErrorMessage'
import useLoadingDelay from 'hooks/useLoadingDelay'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'

interface Props {
  nextPage(page: string): void
  previousPage(page: string): void
}

const UserProfileChangeEmailAddress = (props: Props): JSX.Element => {
  const { nextPage, previousPage } = props
  const [submitErrorMessage, setSubmitErrorMessage] =
    useState<string | null>(null)
  const authentication = useSelector((state: RootState) => state.authentication)
  const userprofile = useSelector((state: RootState) => state.userprofile)
  const dispatch = useDispatch()

  const [updateAccountEmailAddress, { loading }] = useMutation<
    UpdateAccountEmailAddressResponse,
    UpdateAccountEmailAddressVariables
  >(UPDATE_ACCOUNT_EMAIL_ADDRESS)

  async function updateAccountEmailAddressHelper(
    input: UpdateAccountEmailAddressVariables
  ): Promise<UpdateAccountEmailAddressResponseData> {
    const result: UpdateAccountEmailAddressResponseData = {
      success: false,
      errorMessage: null
    }

    try {
      const updateAccountEmailAddressResult = await updateAccountEmailAddress({
        variables: input
      })
      if (
        updateAccountEmailAddressResult.data?.accounts.updateAccountEmailAddress
          .success
      ) {
        result.success = true
        dispatch(setEmailAddress(input.updateEmailAddressData.emailAddress))
        if (userprofile) {
          if (userprofile.emailAddress) {
            dispatch(
              setUserProfileEmailAddress(
                input.updateEmailAddressData.emailAddress
              )
            )
          }
        }
      } else {
        result.success = false
        result.errorMessage =
          updateAccountEmailAddressResult.data?.accounts.updateAccountEmailAddress.errorMessage
      }
    } catch (e) {
      result.success = false
      result.errorMessage =
        'Update of Email Address had an error. Please try again.'
    }
    return result
  }

  const renderFailViolator = () => {
    return (
      <ErrorMessage>
        <span>{submitErrorMessage}</span>
      </ErrorMessage>
    )
  }

  const loadingDelay = useLoadingDelay(loading)

  return (
    <React.Fragment>
      <GoBackHeader
        text='Change Email Address'
        onClick={() => props.previousPage('edit')}
      />
      {loadingDelay && loadingSpinnerPortal()}
      {submitErrorMessage && renderFailViolator()}
      <div className='default-size-container ui-change-email-address-page mt-4 mt-lg-5'>
        <Row>
          <Col xs lg={8}>
            <h2>Change your email address.</h2>
          </Col>
        </Row>
        <p>
          Updating your email address will update the User ID you will use to
          login to your account.
        </p>
        <div className='mt-4'>
          <UserProfileChangeEmailAddressForm
            authentication={authentication}
            nextPage={nextPage}
            previousPage={previousPage}
            updateAccountEmailAddressHelper={updateAccountEmailAddressHelper}
            setSubmitErrorMessage={setSubmitErrorMessage}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default UserProfileChangeEmailAddress
